import type { LpProductListCols } from '@wconcept/wconcept-common/utils/lpProductListCols';

type SpcButtonClickParams = {
  readonly area: string;
  readonly text: string;
};

export const getSpcItemUiButtonClickParams = (
  currentCols: LpProductListCols
): SpcButtonClickParams => ({
  area: 'spc_itemui_button',
  text: `${currentCols}열`,
});

export const getSpcItemListParam = (currentCols: LpProductListCols): string =>
  `${currentCols}열`;
